# <body data-controller="dashboard/errors" data-action="index">
# -> dashboard/errors/index -> ErrorsIndex
pageClass = () ->
  path = $('body').data('controller') + "/" + $('body').data('action')
  className = path.replace(/(?:^(?:dashboard\/)?|\/)(.)/g, (m, l) -> l.toUpperCase())
  return window[className]

$ ->
  if Klass = pageClass()
    new Klass($('body'))

  $("body").find("[data-remote-modal]").remoteModal()
